module.exports = __webpack_public_path__ + "static/media/8-ano.265586e0.png";